export default "__VITE_ASSET__BDfAPGNa__"